/// <amd-module name="Test/TestFlaky/Actions/TestFlakyActionCreator" />
import { TestResultFlakyState } from "Test/common-util/Common";
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { ITestResultTreeData } from "Test/common-util/Contracts/ViewContracts";
import { ITestRunTestCaseResultHolder, TestFlakyActionHub } from "Test/TestFlaky/Actions/TestFlakyActionHub";
import { TestFlakySource } from "Test/TestFlaky/Source/TestFlakySource";
import { Constants } from "Test/TestResultsGrid/TestResultGridHelper";
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

export class TestFlakyActionCreator {
    private _source: TestFlakySource;
    constructor(private _pageContext: IVssPageContext, private _testFlakyActionHub: TestFlakyActionHub) {
        this._source = TestFlakySource.getInstance();
    }

    public initialize(testRunId: number, testResultId: number, testCaseRefId?: number): Promise<void> {
        const runDetailsPromise = this._source.getTestRunById(this._pageContext, testRunId);
        const resultDetailsPromise = this._source.getSelectedTestCaseResult(this._pageContext, testRunId, testResultId);
        let getMarkedFlakyStatus: Promise<TCMContracts.TestResultMetaData[]>;
        if (testCaseRefId) {
            getMarkedFlakyStatus = this._source.getTestResultsMetadata(
                this._pageContext,
                [testCaseRefId.toString()],
                TCMContracts.ResultMetaDataDetails.FlakyIdentifiers
            );
        } else {
            getMarkedFlakyStatus = Promise.resolve([]);
        }

        return Promise.all([runDetailsPromise, resultDetailsPromise, getMarkedFlakyStatus]).then(
            responses => {
                const run: TCMContracts.TestRun = responses[0];
                const result: TCMContracts.TestCaseResult = responses[1];
                const holder: ITestRunTestCaseResultHolder = {
                    testRun: run,
                    testCaseResult: result,
                    flakyIdentifiers: responses[2].length ? responses[2][0].flakyIdentifiers : []
                };
                this._testFlakyActionHub.updateFlakyDialog.invoke(holder);
            },
            error => {
                this._testFlakyActionHub.onError.invoke(error.toString());
            }
        );
    }

    public async updateFlakinessStatus(
        testCaseRefId: number,
        branchName: string,
        isTestResultFlaky: boolean,
        flakyTestResult: ITestResultTreeData
    ): Promise<void> {
        const testMetaDatainput: TCMContracts.TestResultMetaDataUpdateInput = {
            flakyIdentifiers: [
                {
                    branchName: branchName,
                    isFlaky: isTestResultFlaky
                }
            ]
        };
        const results: TCMContracts.TestCaseResult[] = [];
        const flakyState =
            flakyTestResult.isUnreliable || flakyTestResult.flakyState === TestResultFlakyState.Marked
                ? flakyTestResult.flakyState !== TestResultFlakyState.None
                    ? TestResultFlakyState.None
                    : TestResultFlakyState.Unmarked
                : TestResultFlakyState.Marked;
        const testResult = {
            id: flakyTestResult.resultId!,
            customFields: [{ fieldName: Constants.TestResultFlakyStateField, value: flakyState }]
        } as TCMContracts.TestCaseResult;
        results.push(testResult);

        const updateTestResultMetadataPromise = this._source.updateTestResultMetaData(this._pageContext, testCaseRefId, testMetaDatainput);
        const updateTestResultPromise = this._source.updateTestResults(this._pageContext, results, flakyTestResult.runId);

        await Promise.all([updateTestResultMetadataPromise, updateTestResultPromise]).then(
            () => {
                this._testFlakyActionHub.onDismiss.invoke(undefined);
                flakyTestResult.flakyState = flakyState;
            },
            error => {
                this._testFlakyActionHub.onError.invoke(error.toString());
            }
        );
    }
}
